// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bigCaslonRegular": `"big-caslon-fb",serif`,
	"cormorantRegular": `"Cormorant",serif`,
	"ksSansSerif": `KendraScott,sans-serif`,
	"inter": `"Inter",sans-serif`,
	"brandonGrotesque": `"brandon-grotesque","Inter",sans-serif`,
	"gray30": `#e6e9eb`,
	"gray40": `#eeeff0`,
	"gray50": `#f3f0ed`,
	"gray100": `#f9f8f7`,
	"gray200": `#f7f8f9`,
	"gray300": `#f9f9fa`,
	"gray350": `#d9d9d9`,
	"gray375": `#e3e4e8`,
	"gray380": `#f5f5f5`,
	"gray400": `#ede8e3`,
	"gray425": `#e5e5e5`,
	"gray450": `#dbd0c5`,
	"gray500": `#dfe2e4`,
	"gray530": `#ced4da`,
	"gray550": `#c3c6cb`,
	"gray600": `#b3b7bc`,
	"gray650": `#68717e`,
	"gray700": `#ada297`,
	"gray750": `#a0a0a0`,
	"gray800": `#746d63`,
	"gray850": `#756f69`,
	"gray900": `#2a2e33`,
	"grayAlpha5": `rgba(238,239,240,.5)`,
	"grayAlpha3": `hsla(0,0%,100%,.6)`,
	"black": `#000`,
	"black50": `#3c3c3c`,
	"black100": `#0a0a0a`,
	"black200": `#231f20`,
	"black300": `#222`,
	"blackAlpha600": `rgba(10,10,10,.25)`,
	"blackAlpha610": `rgba(10,10,10,.5)`,
	"blackAlpha1": `rgba(0,27,43,.17)`,
	"red18": `#fcefea`,
	"red20": `#f2e7e7`,
	"red30": `#f5cccc`,
	"red100": `#d83105`,
	"red200": `#cc2e04`,
	"red400": `#b14848`,
	"red950": `#963636`,
	"teal400": `#24807e`,
	"teal500": `#1a5c5a`,
	"teal600": `#2a557d`,
	"white": `#fff`,
	"yellow200": `#fdf0bf`,
	"yellow300": `#fcf4d4`,
	"yellow400": `#fef381`,
	"yellow600": `#f1e02b`,
	"purple25": `#f2ecfe`,
	"purple60": `#ebdae5`,
	"purple75": `#e8defc`,
	"purple80": `#d9c3d2`,
	"purple90": `#8f17d1`,
	"purple100": `#674278`,
	"purple300": `#804467`,
	"purple600": `#582946`,
	"purple700": `#4d3159`,
	"green100": `#dcf2e1`,
	"green300": `#90b7a1`,
	"green150": `#e3f2e9`,
	"green500": `#20523f`,
	"green600": `#31755b`,
	"green700": `#89b29b`,
	"green720": `#20523f`,
	"blue200": `#b5e5e1`,
	"blue600": `#437191`,
	"blue700": `#2a557d`,
	"blue800": `#3e444c`,
	"mango400": `#a86500`,
	"peach100": `#fce5d4`,
	"warm400": `#dbd0c5`,
	"gradientMinicartHover": `linear-gradient(270deg, #eddeff, #ffe9cb 52.6%, #f1e02b)`,
	"gradientImageView": `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),linear-gradient(275deg, rgba(173, 162, 151, 0) 7.18%, rgba(173, 162, 151, 0.5) 92.98%)`,
	"gradientRightShadow": `linear-gradient(90deg, var(--chakra-colors-white) calc(100% - 30px), rgba(0, 0, 0, 0.05) 100%)`,
	"ksBrandGradient": `linear-gradient(0deg, #F1E02B 0%, #F1E02B 100%),linear-gradient(270deg, #FCE5D4 0%, #F9E7A7 52.6%, #F1E02B 100%),linear-gradient(270deg, #EDDEFF 0%, #FFE9CB 52.6%, #F1E02B 100%)`,
	"searchBarShadow": `0px 3px 10px rgba(0,0,0,.05)`,
	"sizeGuideShadow": `0 3px 5px rgba(0,0,0,.15)`,
	"ksSpinnerOverlay5": `hsla(0,0%,100%,.5)`,
	"ksSpinnerOverlay6": `hsla(0,0%,100%,.6)`,
	"ksUtilityGradient": `linear-gradient(0deg, #FCF6DE 0%, #FCF6DE 100%),linear-gradient(270deg, #FCE5D4 0%, #F9E7A7 52.6%, #F1E02B 100%),linear-gradient(270deg, #EDDEFF 0%, #FFE9CB 52.6%, #F1E02B 100%)`,
	"yrUtilityGradient": `linear-gradient(0deg, #EDE8E3 0%, #EDE8E3 100%),linear-gradient(270deg, #FCE5D4 0%, #F9E7A7 52.6%, #F1E02B 100%),linear-gradient(270deg, #EDDEFF 0%, #FFE9CB 52.6%, #F1E02B 100%)`,
	"yrInactiveKsBrandGradient": `linear-gradient(0deg, rgba(34, 34, 34, 0.75) 0%, rgba(34, 34, 34, 0.75) 100%),#fff`,
	"yrPromoBarGradient": `linear-gradient(270deg, #BCD1F7 0%, #DFE9E1 52.6%, #F7F6CB 100%),#1a5c5a`,
	"colorbarGradient": `conic-gradient(from 0deg, #F1E02B, #B5E5E1, #83C4BE, #437191, #D0B9EB, #F67880, #FECD93, #F1E02B)`,
	"thumbnailGradient": `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))`,
	"customerDetailsBorder": `linear-gradient(0deg, #EDDEFF 0%, #FFCE90 100%)`,
	"whiteAlpha25": `rgba(247,245,243,.25)`,
	"neutral50": `#fdfcfc`
};
export default ___CSS_LOADER_EXPORT___;
